import { useState } from "react";
import { Alert, Box, Tab, Tabs } from "@mui/material";
import { useGerenteDeEscala } from "@/hooks/useGerenteDeEscala";
import { EscalaRelValeTransporteTab } from "./EscalaRelValeTransporteTab";
import { EscalaRelFolgasTab } from "./EscalaRelFolgasTab";
import { EscalaRelDomingosTab } from "./EscalaRelDomingosTab";
import { EscalaRelAcompanhamentoTab } from "./EscalaRelAcompanhamentoTab";
import { EscalaRelCoberturaTab } from "./EscalaRelCoberturaTab";
import { EscalaRelSemEscalaTab } from "./EscalaRelSemEscalaTab";
import { EscalaRelTransferenciasTab } from "./EscalaRelTransferenciasTab";
import { EscalaRelColaboradoresPorEscalaTab } from "./EscalaRelColaboradoresPorEscalaTab";
import { EscalaRelAlteracoesTab } from "./EscalaRelAlteracoesTab";

// Sub-abas agrupadas por assunto (9 relatórios não cabem numa fileira só de
// abas) — Folha alimenta o vale-transporte e a legislação de folga; Acompanhamento
// é a visão de gestão do mês corrente; Cadastro e Auditoria é o que cruza
// histórico e log (docs/escala/04-contratos.md "Relatórios", ideias novas de
// 2026-09-28). Papel mínimo Gerente — relatório é visão da loja inteira, não
// o filtro de autoria do Encarregado.
type Grupo = "folha" | "acompanhamento" | "auditoria";

export function EscalaRelatoriosTab() {
  const { podeVerRelatorios, carregando } = useGerenteDeEscala();
  const [grupo, setGrupo] = useState<Grupo>("folha");
  const [sub, setSub] = useState(0);

  if (carregando) return null;
  if (!podeVerRelatorios) {
    return (
      <Alert severity="info">
        Os relatórios exigem o papel de Gerente ou Administrador de Escala. Fale com quem administra o
        módulo na sua empresa se precisar de acesso.
      </Alert>
    );
  }

  const mudarGrupo = (novo: Grupo) => {
    setGrupo(novo);
    setSub(0);
  };

  return (
    <Box>
      <Tabs value={grupo} onChange={(_, v: Grupo) => mudarGrupo(v)} sx={{ mb: 2 }}>
        <Tab label="Folha" value="folha" />
        <Tab label="Acompanhamento" value="acompanhamento" />
        <Tab label="Cadastro e Auditoria" value="auditoria" />
      </Tabs>

      {grupo === "folha" && (
        <>
          <Tabs value={sub} onChange={(_, v) => setSub(v)} sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
            <Tab label="Vale-Transporte" />
            <Tab label="Folgas" />
            <Tab label="Domingos Trabalhados" />
          </Tabs>
          {sub === 0 && <EscalaRelValeTransporteTab />}
          {sub === 1 && <EscalaRelFolgasTab />}
          {sub === 2 && <EscalaRelDomingosTab />}
        </>
      )}

      {grupo === "acompanhamento" && (
        <>
          <Tabs value={sub} onChange={(_, v) => setSub(v)} sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
            <Tab label="Acompanhamento do Mês" />
            <Tab label="Cobertura Diária" />
            <Tab label="Colaboradores Sem Escala" />
          </Tabs>
          {sub === 0 && <EscalaRelAcompanhamentoTab />}
          {sub === 1 && <EscalaRelCoberturaTab />}
          {sub === 2 && <EscalaRelSemEscalaTab />}
        </>
      )}

      {grupo === "auditoria" && (
        <>
          <Tabs value={sub} onChange={(_, v) => setSub(v)} sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
            <Tab label="Transferências" />
            <Tab label="Colaboradores por Escala" />
            <Tab label="Alterações" />
          </Tabs>
          {sub === 0 && <EscalaRelTransferenciasTab />}
          {sub === 1 && <EscalaRelColaboradoresPorEscalaTab />}
          {sub === 2 && <EscalaRelAlteracoesTab />}
        </>
      )}
    </Box>
  );
}
